import HttpClientToken from '../../services/HttpClientToken';

import { defaultTipoParte, TipoParteProps } from '../../interfaces/catalogos/TipoParteInterface';

export const TipoParte = () => {

    return new Promise<TipoParteProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoParte/', token)
            .then( ({ data } : { data : TipoParteProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoParte = () => {

    return new Promise<TipoParteProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoParte/ObtenerTipoParte', token)
            .then( ({ data } : { data : TipoParteProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoParte = ( params: TipoParteProps ) => {

    return new Promise<TipoParteProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoParte/Actualizar', params, token)
            .then( ({ data } : { data : TipoParteProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoParte } );
            });

        }

    });

}

export const AgregarTipoParte = ( params: TipoParteProps ) => {

    return new Promise<TipoParteProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoParte/Agregar', params, token)
            .then( ({ data } : { data : TipoParteProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoParte } );
            });

        }

    });

}
